import styled from 'styled-components';

export const Container = styled.section`
  grid-column: 2/10;
  @media (max-width: 768px) {
    grid-column: 1;
    margin: 30px;
  }
`;

export const TableContainer = styled.div`
  .expandable {
    button {
      float: right;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  justify-content: flex-end;
`;
